// extracted by mini-css-extract-plugin
module.exports = {"toolbar":"handoverToolbar_toolbar__2dIeI","toolbarTitle":"handoverToolbar_toolbarTitle__9vTI1"};